import React from 'react'
import styled from 'styled-components'
import SectionWrapperFlexible from '@components/ui/wrappers/SectionWrapperFlexible'
import { breakpoint, color } from '@configs/utilities'
import { HeadingH2 } from '@components/ui/typography/Typography'

const GeneratorTextSection = ({ title, description, list }) => {
  return (
    <SectionWrapperFlexible
      sectionPaddingSm="10px 0 10px 0"
      sectionPaddingMd="30px 0 10px 0"
      sectionPaddingXl="40px 0 20px 0"
    >
      <Wrapper>
        <Article>
          {title ? <HeadingH2>{title}</HeadingH2> : null}
          {description ? (
            <TextItemWrapper>
              {description.map((item, index) => {
                return (
                  <TextItem key={index}>
                    <DescriptionDisplay2Custom key={index}>{item}</DescriptionDisplay2Custom>
                  </TextItem>
                )
              })}
            </TextItemWrapper>
          ) : null}
          {list ? (
            <ListWrapper>
              {list.map((item, index) => {
                return (
                  <List key={index}>
                    <FirstPart>{item.firstPart}</FirstPart>
                    <SecondPart>{item.secondPart}</SecondPart>
                  </List>
                )
              })}
            </ListWrapper>
          ) : null}
        </Article>
      </Wrapper>
    </SectionWrapperFlexible>
  )
}

export default GeneratorTextSection

const Wrapper = styled.div`
  background: ${color.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${color.font};

  h2 {
    text-align: center;
  }
`

const Article = styled.div`
  max-width: 800px;

  &:first-child {
    margin-bottom: 30px;
  }
`

const TextItemWrapper = styled.div``

const TextItem = styled.div`
  margin: 20px 0;
  text-align: center;

  @media screen and (min-width: ${breakpoint.md}) {
    text-align: left;
  }
`

export const DescriptionDisplay2Custom = styled.p`
  font-size: 18px;
  font-weight: 300;
  color: ${color.font};
  line-height: 24px;

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 20px;
    line-height: 28px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 24px;
    line-height: 32px;
  }
`

const ListWrapper = styled.div``

const List = styled.li`
  font-size: 18px;
  font-weight: 300;
  color: ${color.regularFont};
  line-height: 24px;
  margin: 5px 0;

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 20px;
    line-height: 28px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 24px;
    line-height: 32px;
  }
`

const FirstPart = styled.span`
  font-weight: 600;
  margin-right: 5px;
  font-size: 18px;
  color: ${color.regularFont};
  line-height: 24px;

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 20px;
    line-height: 28px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 24px;
    line-height: 32px;
  }
`

const SecondPart = styled.span``
